import type { ConversationAndRequester } from 'lib-shared-types-api';
import { createContext } from 'react';

export type ConversationRowContextValue = {
  readonly conversationAndRequester: ConversationAndRequester;
  /** Whether to show the filter menu item in the row menu. Defaults to true. */
  readonly showRowMenuFilter?: boolean;
};

export const ConversationRowContext =
  createContext<ConversationRowContextValue>(undefined!);
